import formatMoney from '../../core/formatMoney';

export default async (mainSectionTarget) => {
  // Reflect the correct pricing and translations from Shopify Markets
  // https://docs.nosto.com/shopify/shopify-markets/technical-details-how-to-use-it
  if (window.theme.currency_cart !== window.theme.currency) {
    await Nosto.migrateToShopifyMarket({
      productSectionElement: `${mainSectionTarget} [data-product-tile]`,
      productUrlElement: `[data-product-tile-title] a`,
      productTitleElement: `[data-product-tile-title] span`,
      productHandleAttribute: `data-product-handle`,
      priceElement: `[data-product-tile-price] .price__regular`,
      listPriceElement: `[data-product-tile-price] .price__compare-at`
    });

    // Promo logic after Nosto price update
    document.querySelectorAll(`${mainSectionTarget} [data-product-tile]`).forEach((productTile) => {
      const promoEl = productTile.querySelector('[data-product-tile-price-promo]');
      if (promoEl) {
        // const raw_price = Number(promoEl.dataset.rawPrice);
        const priceValue = productTile.querySelector('[data-product-tile-price] .price__regular')?.textContent;
        if (!priceValue) return;
        
        // Remove the formatting to get the raw price number
        const raw_price = Number(priceValue.replace(/[^0-9.-]+/g,"")) / 100;

        const promo_discount = Number(promoEl.dataset.promoDiscount);

        // Get the color from the style
        const promoValEl = promoEl.querySelector('.price__promo');
        const promo_discount_color = (promoValEl) ? window.getComputedStyle(promoValEl).color : '#FF0000';

        promoEl.innerHTML = `<span class="price__promo" style="color: ${promo_discount_color} !important;">${formatMoney(String((raw_price - ((raw_price * promo_discount) / 100)).toFixed(2)), theme.moneyFormat )} after ${promo_discount}% off</span>`;
      }
    });
  }
};
